export const API_ENDPOINT =
  typeof window !== 'undefined' && process.env.NODE_ENV !== 'development'
    ? window.origin
    : process.env.REACT_APP_API_ENDPOINT; // for development purposes we use proxy defined in the package.json
export const IS_LOCAL_DEVELOPMENT = process.env.NODE_ENV === 'development';
